import { compose } from 'lodash/fp'
import PasswordReset from './PasswordReset'
import withReduxForm from './withReduxForm'
import withLoadLanguage from './withLoadLanguage'
import withState from './withState'

export default compose(
  withReduxForm,
  withState,
  withLoadLanguage,
)(PasswordReset)
